const ages = [
    {
        text: 'Từ 0 đến 5 tuổi',
        value: [0, 6], //[0,6)
    },
    {
        text: 'Từ 6 đến 17 tuổi',
        value: [6, 18], //[0,18)
    },
    {
        text: 'Từ 18 đến 60 tuổi',
        value: [18, 61], //[18,61)
    },
    {
        text: 'Trên 60 tuổi',
        value: [60], //[60]
    },
]; //bé hơn. cuối lớn hơn
export default ages;
